import { render, staticRenderFns } from "./RateioRequisicaoForm.vue?vue&type=template&id=b818e0d2"
import script from "./RateioRequisicaoForm.vue?vue&type=script&lang=js"
export * from "./RateioRequisicaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports